import { Spread } from 'braid-design-system';

const CTASectionView = ({
  textContent,
  buttonsContent,
}: {
  textContent?: JSX.Element | null;
  buttonsContent?: JSX.Element | null;
}) => (
  <Spread space="gutter" alignY="bottom">
    {textContent}
    {buttonsContent}
  </Spread>
);

export default CTASectionView;
